import { render, staticRenderFns } from "./ActiveDangerousButton.vue?vue&type=template&id=6aefebb2&scoped=true&"
import script from "./ActiveDangerousButton.vue?vue&type=script&lang=js&"
export * from "./ActiveDangerousButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aefebb2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
